import { IAnalyticsAdapter } from "./IAnalyticsAdapter";
import { ServiceType } from "../ServiceManager";
import { ClientWebsiteConfig } from "../Config";
import { AnalyticsEvent, AnalyticsEventType, AnalyticsPageView } from "./AnalyticsEvents";
import { Logger, LogLevel } from "../Logger";

class GoogleAnalyticsAdapter implements IAnalyticsAdapter {
    Type: ServiceType = ServiceType.Analytics;
    Id: string = 'GoogleAnalyticsAdapter';
    GA: any;

    constructor(config: ClientWebsiteConfig) {
      this.InitGoogleAnalytics().then((gtag) => {
        gtag('js', new Date());

        config.Settings?.Analytics.GoogleAnalyticsTrackingIds.forEach((id) => {
            gtag('config', id, { 'send_page_view': false })

            Logger.Log(LogLevel.Debug, '[Google Analytics]', `Initialised tracker ${id}`);
        });
      })
    }

    InitGoogleAnalytics(): Promise<any> {
      return new Promise((resolve) => {
        const win = window as any

        const scriptTag = document.createElement('script') as HTMLScriptElement

          scriptTag.onload = () => {
            resolve(win['gtag'] as any)
            Logger.Log(LogLevel.Debug, '[Google Analytics]', 'GTAG Loaded')
          }

          win['dataLayer'] = win['dataLayer'] || []
          win['gtag'] = function() { (win['dataLayer'] as any).push(arguments) }

          scriptTag.src = 'https://www.googletagmanager.com/gtag/js'

          document.body.appendChild(scriptTag)
      })
    }

    Record(event: AnalyticsEvent): void {
        Logger.Log(LogLevel.Debug, '[Google Analytics]', 'Sending event', event);

        const win = window as any

        const ga: any = win['gtag']

        switch(event.Type) {
            case AnalyticsEventType.PageView:

                const evt = event as AnalyticsPageView;

                ga('event', 'page_view', {
                  page_title: evt.Title,
                  page_location: window.location.origin + evt.Page,
                  page_path: evt.Page,
                })
                
                break;
            case AnalyticsEventType.ContactFormSubmit:

              ga('event', 'Submit Contact Form')

                break;
        }
    }
}

export { GoogleAnalyticsAdapter }
